/**
 * Extrahiert eine lesbare Fehlermeldung aus einem Axios-Fehler.
 * 
 * Unterstützt:
 * - detail als String
 * - detail als Objekt mit message (z.B. {message: "...", code: "reason_required"})
 * - detail als Array (FastAPI-Validierung) -> verbindet msg-Werte
 * - Fallback wenn nichts passt
 * 
 * @param {Error} error - Axios error object
 * @param {string} fallback - Fallback message wenn nichts extrahierbar
 * @returns {string} Die extrahierte oder Fallback-Fehlermeldung
 */
export function getErrorMessage(error, fallback = 'Ein Fehler ist aufgetreten') {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return fallback;
  }
  
  // String
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Objekt mit message
  if (typeof detail === 'object' && detail.message) {
    return detail.message;
  }
  
  // Array (FastAPI validation errors)
  if (Array.isArray(detail)) {
    const messages = detail
      .map(item => item.msg || item.message || JSON.stringify(item))
      .filter(Boolean);
    return messages.length > 0 ? messages.join('; ') : fallback;
  }
  
  return fallback;
}

/**
 * Prüft ob der Fehler den Code "reason_required" hat.
 * 
 * @param {Error} error - Axios error object
 * @returns {boolean}
 */
export function isReasonRequiredError(error) {
  const data = error?.response?.data;
  const detail = data?.detail;
  if (data?.detail_raw?.code === 'reason_required') {
    return true;
  }
  return typeof detail === 'object' && detail?.code === 'reason_required';
}

export default getErrorMessage;
